import { Chip as UnstyledChip, styled } from "@mui/material";

export const Container = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(1),
}));

export const ChipsContainer = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  flexWrap: "wrap",
  gap: theme.spacing(1),
}));

export const Chip = styled(UnstyledChip)(({ theme }) => ({
  fontWeight: 500,
  letterSpacing: "0.16px",
  lineHeight: theme.spacing(2),
  overflow: "hidden",
  padding: theme.spacing(0.375, 0.5),
  textOverflow: "ellipsis",
}));
